import { getUserData, getUsers, removeUser, updateUser } from '@/store/thunks/users';
import { TUser } from '@/types/users';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TUsersState = {
    list: TUser[]
    user: TUser | undefined
    isLoading: boolean
}

const initialState: TUsersState = {
    isLoading: false,
    user: undefined,
    list: [],
};

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<TUser | undefined>) => {
            state.user = action.payload;
            state.isLoading = false;
        },
        setIsPending: (state) => {
            state.isLoading = true;
        },
        setIsLoaded: (state) => {
            state.isLoading = false;
        },
    },
    extraReducers: builder => {
        builder.addCase(getUsers.pending, usersSlice.caseReducers.setIsPending);
        builder.addCase(getUsers.fulfilled, (state, action: PayloadAction<TUser[]>) => {
            state.list = action.payload || [];
            state.isLoading = false;
        });

        builder.addCase(getUserData.pending, usersSlice.caseReducers.setIsPending);
        builder.addCase(getUserData.fulfilled, usersSlice.caseReducers.setUser);

        builder.addCase(updateUser.pending, usersSlice.caseReducers.setIsPending);
        builder.addCase(updateUser.fulfilled, usersSlice.caseReducers.setUser);

        builder.addCase(removeUser.pending, usersSlice.caseReducers.setIsPending);
        builder.addCase(removeUser.fulfilled, (state) => {
            state.user = undefined;
        });
    },
});

export const { setUser, setIsPending, setIsLoaded } = usersSlice.actions;
